import React, { useContext } from 'react';

const CitiesContext = React.createContext();

export const CitiesProvider = CitiesContext.Provider;
export const CitiesConsumer = CitiesContext.Consumer;

export const useCitiesContext = () => useContext(CitiesContext);

export default { CitiesProvider, CitiesConsumer, useCitiesContext };
